import { render, staticRenderFns } from "./stock-summary.vue?vue&type=template&id=0b3c5da9&"
import script from "./stock-summary.vue?vue&type=script&lang=js&"
export * from "./stock-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports